import React from 'react'
import { Widget } from '@typeform/embed-react'

export const Typeform = ({ id, hidden, mode }) =>
    mode === 'edit' ? (
        <p>Form not viewable in edit mode. Enter preview to see it.</p>
    ) : (
        <Widget
            id={id}
            style={{ height: '75vh', width: '100%' }}
            hidden={hidden}
            inlineOnMobile
        />
    )
